import { render, staticRenderFns } from "./TeacherIntroduct.vue?vue&type=template&id=36caa1b3&scoped=true&"
import script from "./TeacherIntroduct.vue?vue&type=script&lang=js&"
export * from "./TeacherIntroduct.vue?vue&type=script&lang=js&"
import style0 from "./TeacherIntroduct.vue?vue&type=style&index=0&id=36caa1b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36caa1b3",
  null
  
)

export default component.exports